document.addEventListener("DOMContentLoaded", () => {
  // === Mémoire de la page principale ===
  const mainPages = ["index.html", "projets.html"];
  const currentPage = window.location.pathname.split("/").pop();

  if (mainPages.includes(currentPage)) {
    sessionStorage.setItem("mainPage", currentPage);
  }

  // === Flèche retour ===
  const backArrow = document.getElementById("back-arrow");
  if (backArrow) {
    backArrow.style.cursor = "pointer";
    backArrow.addEventListener("click", () => {
      const mainPage = sessionStorage.getItem("mainPage");
      if (mainPage) {
        window.location.href = mainPage;
      } else {
        // fallback si jamais pas de mainPage mémorisée
        window.location.href = "index.html";
      }
    });
  }
});
